module.exports = __webpack_public_path__ + "img/bardhall_tech_Normal_ua.bd0c7b60.webp";